<template>
  <div>
    <pre-header/>
    <navigation/>
    <app-main/>
    <footer-bar/>
    <login-dialog id="loginModel"/>
    <trial-dialog id="trialModel"/>
    <common-dialog id="renewalModal" :staticmessage="renewalmsg"/>
    <div id="mainloading" :class="{ 'z-hide': !isloading }" class="load8"><div class="loader"/></div>
  </div>
</template>

<script>
import PreHeader from './components/PreHeader'
import Navigation from './components/Navigation'
import AppMain from './components/AppMain'
import FooterBar from './components/Footer'
import TrialDialog from '@/components/TrialDialog'
import LoginDialog from '@/components/LoginDialog'
import CommonDialog from '@/components/CommonDialog'

export default {
  name: 'Layout',
  components: {
    PreHeader,
    Navigation,
    FooterBar,
    AppMain,
    TrialDialog,
    LoginDialog,
    CommonDialog
  },
  data() {
    return {
      renewalmsgprefix: '感谢您对必孚（中国）的认可和支持，您的账号',
      renewalmsgsuffix: ' 结束必孚会员服务，请联系必孚（中国）工作人员进行续订。'
    }
  },
  computed: {
    isloading() {
      return this.$store.getters.isLoading
    },
    renewalmsg() {
      return this.renewalmsgprefix +
      (new Date(this.$store.getters.userow.ChargeExpireDate) < new Date() ? '已' : '将') +
      '于 ' + this.getTime(this.$store.getters.userow.ChargeExpireDate) +
      this.renewalmsgsuffix
    }
  },
  created() {
    sessionStorage.lang = 'zh-cn'
    this.$i18n.locale = sessionStorage.lang
  },
  methods: {
    getTime(time) {
      return time ? time.substring(0, 10) : ''
    }
  }
}
</script>

<style>
.z-hide { display: none }
</style>

<style scoped>
.minheight {
    /* min-height: 100vh; */
    height: auto !important;
}

.load8 {
    /* min-height: 100vh; */
    height: auto !important;
}

.load8 .loader {
    font-size: 1px;
    position: absolute;
    margin: -75px 0 0 -75px;
    top: 50%;
    left: 50%;
    border-top: 3.1px solid rgba(60, 60, 255, 0.5);
    border-right: 3.1px solid rgba(60, 60, 255, 0.5);
    border-bottom: 3.1px solid rgba(60, 60, 255, 0.5);
    border-left: 3.1px solid transparent;
    -webkit-animation: load8 2.1s infinite linear;
    animation: load8 2.1s infinite linear;
    z-index: 9999;
    position: fixed;
}

.load8 .loader,
.load8 .loader:after {
    border-radius: 50% !important;
    width: 150px;
    height: 150px;
}

@-webkit-keyframes load8 {
    0% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }

    100% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}

@keyframes load8 {
    0% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }

    100% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/layout_pork/index.vue